import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading, KPITile } from "../components/Common";

export default function HR() {
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.hrStaff().then(({ data }) => setStaff(data)).catch(() => setStaff([])); }, []);
  if (staff === null) return <Loading />;
  const depts = [...new Set(staff.map((s) => s.department))];
  return (
    <div data-testid="hr-page">
      <PageHeader kicker="Human Resources" title="Faculty & Staff" subtitle="Departments, contracts and staffing overview." />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <KPITile testId="hr-total" tone="dark" label="Staff" value={staff.length} />
        <KPITile testId="hr-depts" label="Departments" value={depts.length} />
        <KPITile testId="hr-ft" label="Full-time" value={staff.filter((s) => s.contract_type === "Full-time").length} />
      </div>
      <Section>
        <DataTable
          columns={[
            { key: "name", label: "Name", render: (r) => `${r.first_name} ${r.last_name}` },
            { key: "role", label: "Role" },
            { key: "department", label: "Department" },
            { key: "email", label: "Email" },
            { key: "contract_type", label: "Contract" },
          ]}
          rows={staff}
        />
      </Section>
    </div>
  );
}
